export default {
    "entityName": "request",
    "fields": [
        {
            "value": "request_date",
            "text": "Request date",
            "type": "datetime"
        },
        {
            "value": "provider_id",
            "id": "provider_id",
            "reference": "drug",
            "text": "Provider",
            "type": "autocomplete",
            "title": "provider.name",
            "subtitle": "provider.city",
            filter: item => ({ protocol_id: item.protocol_id }),
        }
    ]
}